import { computed } from '@vue/composition-api'
import store from '@/store'
import { parseRequestError } from '@/helpers/helpers'

export default () => {
  const me = computed(() => store.getters['auth/getUser'])
  const openStripePortal = () => {
    store.dispatch('auth/createPortalSession')
      .then(response => {
        window.open(response.data.url, '_blank')
      })
      .catch(err => parseRequestError(err))
  }
  return {
    me,
    openStripePortal,
  }
}
